import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  handleAuthenticate,
  handleLogout,
  handleResetPassword,
  uploadBulkEntry,
  getUploadedFiles,
  downloadStudentActivity
} from './api'
import { initialState, UpdateActivityData, UploadFileResponse } from './types'

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    updateIsLoggedIn: (state, action: PayloadAction<boolean>) => {
      state.isLoggedIn = action.payload
    },
    updateHasError: (state, action: PayloadAction<boolean>) => {
      state.hasError = action.payload
    },
    updateUserName: (state, action: PayloadAction<string>) => {
      state.userName = action.payload
    },
    updatePassword: (state, action: PayloadAction<string>) => {
      state.password = action.payload
    },
    updateSelectedBatch: (state, action: PayloadAction<string>) => {
      state.selectedBatch = action.payload
    },
    updateSelectedCourse: (state, action: PayloadAction<string>) => {
      state.selectedCourse = action.payload
    },
    updateStudentActivity: (
      state,
      action: PayloadAction<UpdateActivityData>
    ) => {
      state.studentActivity[action.payload.key] = action?.payload.value
    }
  },
  extraReducers: {
    [handleAuthenticate.pending.toString()]: (state) => {
      state.isLoading = true
      state.hasError = false
    },
    [handleAuthenticate.fulfilled.toString()]: (state, action) => {
      state.isLoading = false
      state.isLoggedIn =
        !!action.payload && !action.payload.isResetPasswordRequired
      state.userInfo = action.payload
      state.hasError = !action.payload
    },
    [handleAuthenticate.rejected.toString()]: (state) => {
      state.isLoading = false
      state.isLoggedIn = false
      state.hasError = true
    },
    [handleLogout.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [handleLogout.fulfilled.toString()]: (state) => {
      state.isLoading = false
      state.isLoggedIn = false
      state.userInfo = null
    },
    [handleLogout.rejected.toString()]: (state) => {
      state.isLoading = false
    },
    [handleResetPassword.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [handleResetPassword.fulfilled.toString()]: (state) => {
      state.isLoading = false
    },
    [handleResetPassword.rejected.toString()]: (state) => {
      state.isLoading = false
    },
    [uploadBulkEntry.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [uploadBulkEntry.fulfilled.toString()]: (state) => {
      state.isLoading = false
    },
    [uploadBulkEntry.rejected.toString()]: (state) => {
      state.isLoading = false
      state.hasError = true
    },
    [getUploadedFiles.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [getUploadedFiles.fulfilled.toString()]: (
      state,
      action: PayloadAction<UploadFileResponse>
    ) => {
      state.isLoading = false
      state.uploadedFiles.fileList = action.payload.fileList
      state.uploadedFiles.currentPage = action.payload.currentPage
      state.uploadedFiles.pageSize = action.payload.pageSize
    },
    [getUploadedFiles.rejected.toString()]: (state) => {
      state.isLoading = false
    },
    [downloadStudentActivity.pending.toString()]: (state) => {
      state.isLoading = true
      state.hasError = false
    },
    [downloadStudentActivity.fulfilled.toString()]: (
      state,
      action: PayloadAction<string>
    ) => {
      state.isLoading = false
      state.downloadFile = action.payload
      state.studentActivity = initialState.studentActivity
    },
    [downloadStudentActivity.rejected.toString()]: (state) => {
      state.isLoading = false
      state.studentActivity = initialState.studentActivity
      state.hasError = true
    }
  }
})

export default userSlice.reducer
